<template>
  <van-popup v-model="addressListShow"
             position="bottom"
             :style="{ height: '100%' }">
    <div class="addressList">
      <div class="addressList_top">
        <div class="addressList_search relative">
          <i class="f16_rem iconfont icon-search" @click="shopDeliveryList"></i>
          <input type="text" v-model="nameOrPhone" placeholder="输入收货人名称">
        </div>
      </div>
      <div class="addressList_main">
        <ul>
          <template v-for="address of addressList">
            <li :class="{addChoose_active:address.deliveryId === chosenAddressId}"  v-if="address.deliveryId"
                :key="address.deliveryId">
              <div class="inlineblock max_w260" @click="addressSelect(address)">
                <p class="gray_3 f14_rem fb_600 ellipsis">
                  <span class="mar15_r">{{address.name}}</span>
                  <span>{{address.tel}}</span>
                </p>
                <p class="gray_3 f12_rem ellipsis">{{address.addr}}</p>
              </div>
              <van-icon name="edit" color="#333" size="14" @click="addressUpdate(address.deliveryId)" class="add_item_edit fb" />
              <van-icon name="delete-o" color="#333" size="14" @click="addressDelete(address.deliveryId)" class="add_item_delete fb" />
            </li>
          </template>
        </ul>
      </div>
      <div class="addressList_bottom">
        <span class="b_red white bor_red mar15_b" @click="addressDialog">新增收货地址</span>
        <span class="red b_f7e8ea bor_red" @click="addressCancel">返回</span>
      </div>
      <!--新增收货地址-->
      <!--eslint-disable-next-line-->
      <van-popup v-model:show="addAddressShow"
                 position="bottom"
                 :style="{ height: '100%' }">
        <div class="addAddress_pop">
          <div class="addAddress_pop_main">
            <van-field v-model="addAddress.name" label="联系人" placeholder="您的姓名" />
            <van-field v-model="addAddress.tel" type="tel" maxlength="11" label="联系电话" placeholder="您的手机" />
            <van-field v-model="addAddress.areaName" label="配送区域" placeholder="点击选择配送区域"
                       readonly @click="addAreaShow = true" />
            <van-field v-model="addAddress.addr" label="详细地址" placeholder="请填写您的详细地址" />
            <van-cell center title="默认地址">
              <template #right-icon>
                <van-switch v-model="addAddress.isdefault" size="20px" active-color="#ff0023" inactive-color="#ddd"/>
              </template>
            </van-cell>

          </div>
          <div class="addAddress_pop_btn">
            <span class="b_red white bor_red" @click="addressSave">确定</span>
            <span class="bor_ddd b_white gray_3 " @click="addAddressShow = false">返回</span>
          </div>
        </div>
      </van-popup>
      <!--新增收货地址地区选择-->
      <!--eslint-disable-next-line-->
      <van-popup v-model:show="addAreaShow"
                 :safe-area-inset-bottom="true"
                 closeable
                 round
                 position="bottom">
        <van-cascader
          v-model="addAddress.areaId"
          title="请选择所在地区"
          :options="options"
          @change="areaChange"
          @finish="areaSelect"
          :field-names="fieldNames"
          @close="addAreaShow = false"
        />
      </van-popup>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from "vuex";
import { Toast, Dialog } from "vant";
import common from "@/assets/js/common";
// import cityData3 from '@/assets/js/city.data-3';

export default {
  props: {
    addressListShow: {
      type: Boolean,
      default: false
    },
    selectDeliveryId: Number,
    cusboId: String,
    selectAddress: {
      type: Function,
      default: null
    },
    updateAddress: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      fieldNames: {
        text: "name",
        value: "id",
        children: "children"
      },
      options: [],
      areaIndex: [],
      addAddressShow: false, // 是否显示新增收货地址
      addAreaShow: false, // 是否显示新增收货地址省市区选择
      disabledList: [ // 超出范围地址
      ],
      addressInfo: {}, // 编辑地址的地址信息
      // areaList: cityData, // 省市县的数据
      areaList: {}, // 省市县的数据
      searchResult: [], // 搜索详细地址联想的地址
      chosenAddressId: this.selectDeliveryId,
      addressList: [],
      nameOrPhone: "",
      addAddress: {
        name: "",
        tel: "",
        areaId: "",
        addr: "",
        isdefault: true,
        areaName: ""
      }
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    if (!common.isLogin(this.userInfo.id)) {
      return;
    }
    this.getAreas(0, 0);
    this.shopDeliveryList();
  },
  methods: {
    // 获取省市县 index 0-省 1-市 2-县 3-街道
    getAreas(areaId, index) {
      this.$store.dispatch("app/getAreas", {
        parentId: areaId
      }).then((data) => {
        const list = data.map((item) => {
          const { id, end, name } = item;
          if (end) {
            return { id, end, name };
          }
          return {
            id, end, name, children: []
          };
        });
        if (index === 0) {
          this.options = list;
        } else if (index === 1) {
          this.options.forEach((item) => {
            if (item.id === areaId) {
              item.children = list;
            }
          });
        } else if (index === 2) {
          const parentId = this.areaIndex[0];
          this.options.forEach((item) => {
            if (item.id === parentId) {
              item.children.forEach((item1) => {
                if (item1.id === areaId) {
                  item1.children = list;
                }
              });
            }
          });
        } else if (index === 3) {
          const parentId = this.areaIndex[0];
          const cityId = this.areaIndex[1];
          this.options.forEach((item) => {
            if (item.id === parentId) {
              item.children.forEach((item1) => {
                if (item1.id === cityId) {
                  item1.children.forEach((item2) => {
                    if (item2.id === areaId) {
                      item2.children = list;
                    }
                  });
                }
              });
            }
          });
        }
      });
    },
    // 选择省市县的change事件
    areaChange(event) {
      console.log("change", event);
      const { value, tabIndex, selectedOptions } = event;
      const { end, children } = selectedOptions[tabIndex];
      if (tabIndex === 0) {
        this.areaIndex = [value, "", ""];
      } else if (tabIndex === 1) {
        const province = this.areaIndex[0];
        this.areaIndex = [province, value, ""];
      } else if (tabIndex === 2) {
        this.areaIndex[2] = value;
      }
      // end 是否结束查询 如果有子级元素结束查询
      if (end || children.length) {
        return;
      }
      const index = tabIndex + 1;
      this.getAreas(value, index);
    },
    shopDeliveryList() {
      const param = {
        nameOrPhone: this.nameOrPhone,
        cusboId: this.cusboId
      };
      this.$store.dispatch("order/confirmOrder/shopDeliveryList", this.$qs.stringify(param)).then((data) => {
        this.addressList = data.searchDeliveryList || [];
      }).catch(() => {
      });
    },
    addressSelect(item) {
      this.chosenAddressId = item.deliveryId;
      this.selectAddress(item);
      // this.$emit('selectAddress',item);
      // this.$emit('updateAddress',item);
    },
    addressDialog() {
      this.addAddress = {
        name: "",
        tel: "",
        areaId: "",
        addr: "",
        isdefault: true,
        areaName: ""
      };
      this.addAddressShow = true;
    },
    addressUpdate(deliveryId) {
      this.addAddressShow = true;
      this.$store.dispatch("goodDetails/goodDetails/alterDelivery", this.$qs.stringify({ deliveryId })).then((data) => {
        if (data && data.memberDelivery) {
          this.addAddress = data.memberDelivery;
          this.$set(this.addAddress, "areaName", data.memberDelivery.areaFullName);
          this.$set(this.addAddress, "isdefault", data.memberDelivery.isDefault === 1);
        }
      });
    },
    addressDelete(deliveryId) {
      Dialog.confirm({
        title: "提示",
        message: "是否确认删除?"
      }).then(() => {
        this.$store.dispatch("goodDetails/goodDetails/deleteAddr", this.$qs.stringify({ deliveryId })).then((data) => {
          if (data.messageJO && data.messageJO.code === "001") {
            const indexOf = this.addressList.findIndex(item => item.deliveryId === deliveryId);
            if (indexOf !== -1) {
              this.addressList.splice(indexOf, 1);
            }
            this.$emit("getAddress", {});
          } else {
            Toast("删除失败");
          }
        });
      }).catch(() => {

      });
    },
    // 新增地址确定
    addressSave() {
      const {
        deliveryId, name, tel, addr, areaId, isdefault
      } = this.addAddress;
      if (!name || !tel || !addr || !areaId) {
        Toast("请补全增加信息");
        return;
      }
      const isDefault = isdefault === true ? 1 : 0;
      let param = {
        name, tel, addr, areaId, isDefault, cusboId: this.cusboId
      };
      let url = "goodDetails/goodDetails/addAddr";
      if (deliveryId) {
        if (tel.indexOf("****") !== -1) {
          param = {
            deliveryId, name, addr, areaId, isDefault, cusboId: this.cusboId
          };
        } else {
          param = {
            deliveryId, name, tel, addr, areaId, isDefault, cusboId: this.cusboId
          };
        }
        url = "goodDetails/goodDetails/updateAddr";
      }
      let linDeliveryId = deliveryId;
      this.$store.dispatch(url, this.$qs.stringify(param)).then((data) => {
        if (!deliveryId) {
          linDeliveryId = data.deliveryId;
        }
        this.$store.dispatch("goodDetails/goodDetails/shopDeliveryList", this.$qs.stringify({ deliveryId: linDeliveryId })).then((data1) => {
          if (!data1.deliveryList || data1.deliveryList.length === 0) {
            Toast("地址保存失败");
            return;
          }
          const memberDelivery = data1.deliveryList[0];
          // 修改
          if (deliveryId) {
            const indexOf = this.addressList.findIndex(item => item.deliveryId === deliveryId);
            if (indexOf !== -1) {
              this.addressList.splice(indexOf, 1, memberDelivery);
            }
            this.updateAddress(memberDelivery);
          } else {
            this.addressList.unshift(memberDelivery);
            this.addressSelect(memberDelivery);
          }
          // 选中默认地址
          this.chosenAddressId = memberDelivery.deliveryId;
          this.addAddressShow = false;
        });
      });
    },
    areaSelect(item) {
      console.info(item);
      this.addAreaShow = false;
      const areaName = [];
      item.selectedOptions.forEach((area) => {
        areaName.push(area.name);
      });
      this.$set(this.addAddress, "areaName", areaName.join(""));
    },
    // 返回
    addressCancel() {
      this.addAddress = {
        name: "",
        tel: "",
        areaId: "",
        addr: "",
        isdefault: true,
        areaName: ""
      };
      this.$emit("update:addressListShow", false);
    }
  },
  watch: {
    selectDeliveryId(newValue) {
      this.chosenAddressId = newValue;
    }
  }
};
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>
